module.exports = __webpack_public_path__ + "media/audio8.bdad653d.mp3";